
export default {
  name: "Form",
  props: {
    onSubmit: {
      type: Function
    }
  }
};
